
const digest = '7798464bbe29ce2b454959f17fac76fc979ad9cb20724450d930bcc6807de9da';
const classes = {"wrapper":"_wrapper_1vupc_1","button":"_button_1vupc_4","menu":"_menu_1vupc_14","close":"_close_1vupc_28","menuButton":"_menuButton_1vupc_38"};
const css = `._wrapper_1vupc_1 {
  position: relative;
}
._wrapper_1vupc_1 ._button_1vupc_4 {
  background-color: #E9EFFB;
  border-radius: 100%;
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
._wrapper_1vupc_1 ._menu_1vupc_14 {
  position: absolute;
  padding: 40px 16px 16px 16px;
  background-color: #ffffff;
  border-radius: 25px;
  border: 1px solid #eaedf3;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 100;
}
._wrapper_1vupc_1 ._menu_1vupc_14 ._close_1vupc_28 {
  position: absolute;
  right: 14px;
  top: 14px;
  width: 20px;
  height: 20px;
  background: url("/dist/icons/react/xmark-blue.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}
._wrapper_1vupc_1 ._menu_1vupc_14 ._menuButton_1vupc_38 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
  cursor: pointer;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  